<h1 mat-dialog-title>Want to View Work Item ? </h1>
<mat-dialog-content>
    <p>Select Entity and Enter the Work Item Number</p>
    <div>
        <app-org-bu-project-team-structure [dataForTree]="this.dataSource.data"
                                           [isApplySelectableFilter]="true"
                                           [selectedEntityName]="selectedEntityName"
                                           [selectedEntityInfo]="selectedEntityInfo"
                                           (selectedEntityChange)="handleSelectedEntityNew($event)">
        </app-org-bu-project-team-structure>
    </div>
    <div class="d-flex justify-content-between align-items-center gap-1 pt-3">
            <mat-form-field *ngIf="this.teamCode">
                <span matTextPrefix *ngIf="teamCode">{{ teamCode }} &nbsp; &nbsp; &nbsp;</span>
                <mat-label>Work Item Number</mat-label>
                <input matInput type="number" id="taskNumInputId" [(ngModel)]="taskNumber" min="0" (keydown)="taskNumberKeyDownEvent($event)">
            </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end gap-1 align-items-center">
    <button mat-flat-button (click)="closeDialog()" >Close</button>
    <button (click)="taskNumberEntered()" [disabled]="isHideGetTaskBtn()" [class.disabled]="isHideGetTaskBtn()" class="tse-btn-primary" id="getTaskBtnId">Continue
    </button>
</mat-dialog-actions>
